// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3P3u5","file":"styles_file__1HMOv"};